module.exports = __webpack_public_path__ + "img/subscription-active.a5923af5.svg";